const DEFAULT_ROOT_FONT_SIZE = 10;
const getFontSizePx = ({ fontSize, rootFontSize = DEFAULT_ROOT_FONT_SIZE }) => `${parseFloat(fontSize) * rootFontSize}px`;
export const emotionRemToPx = (rootFontSize) => element => {
    const { props, value } = element;
    if (props === 'font-size' && value.includes('rem')) {
        element.value = `font-size:${getFontSizePx({
            fontSize: value.split(':')[1],
            rootFontSize
        })};`;
    }
};
//# sourceMappingURL=index.js.map